import { jsxs, jsx } from 'react/jsx-runtime';
import { Button } from '../ui/button.js';
import { Field, FieldLabel } from '../ui/field.js';
import { LineIcon } from '../ui/icons/LineIcon.js';
import { cn } from '../../lib/utils.js';
import { InfoText } from './infoText.js';

const FieldWrapper = ({
  variants = "small",
  ref,
  color,
  className,
  title,
  titleId,
  subTitle,
  labelFor,
  isIndented = false,
  isToolTip = false,
  isRequired = false,
  isSuccess,
  isError,
  helpMessage,
  hasIcon = true,
  children,
  onClick,
  rightButton
}) => {
  return /* @__PURE__ */ jsxs(Field, { ref, onClick, className, children: [
    title && /* @__PURE__ */ jsxs("div", { className: cn("flex gap-0.5 items-center", rightButton && "w-full"), children: [
      /* @__PURE__ */ jsxs(FieldLabel, { htmlFor: labelFor, id: titleId, children: [
        /* @__PURE__ */ jsxs("div", { className: cn("flex gap-0.5 items-center"), children: [
          /* @__PURE__ */ jsx(
            "span",
            {
              className: cn(
                "font-weight-medium  text-basic-04 whitespace-pre-line label-text",
                variants === "medium" ? "body-lg" : "body-md",
                // isDesktop,
                //   ? 'body-lg'
                //   : 'body-md',
                color === "blue" && "text-blue-800",
                color === "gray" && "text-basic-04"
              ),
              children: title
            }
          ),
          subTitle
        ] }),
        isRequired && /* @__PURE__ */ jsx("span", { className: "required-dot", title: "필수", children: /* @__PURE__ */ jsx("span", { className: "sr-only", children: "new" }) }),
        isToolTip && /* @__PURE__ */ jsx(Button, { variant: "ghost", className: "h-0 px-0 ml-1", children: /* @__PURE__ */ jsx(
          LineIcon,
          {
            icoColor: "bg-icon-primary-04",
            icoName: "ico-tooltip",
            type: "xs"
          }
        ) })
      ] }),
      rightButton && /* @__PURE__ */ jsx("div", { className: "ml-auto", children: rightButton })
    ] }),
    children,
    helpMessage && /* @__PURE__ */ jsx("div", { className: cn(isIndented && "ml-8 mt-[-4px]", "!w-auto"), children: !isError ? hasIcon ? /* @__PURE__ */ jsx(InfoText, { type: isSuccess ? "primary" : "default", text: helpMessage }) : /* @__PURE__ */ jsx("p", { className: "mt-2 body-sm text-center text-state-informative whitespace-pre-line", children: helpMessage }) : hasIcon ? /* @__PURE__ */ jsx(InfoText, { type: "warning", text: helpMessage }) : /* @__PURE__ */ jsx("p", { className: "mt-2 body-sm text-center text-state-danger whitespace-pre-line", children: helpMessage }) })
  ] });
};

export { FieldWrapper };
